import { axios, Response } from '../index'

type Body = {
  patientIds: string[]
}

const addPatientToGroup = (groupId: string, body: Body): Response<Body> => {
  return axios.post(`/v1/groups/${groupId}/patients`, body)
}

export default addPatientToGroup
